import React from 'react'
import './Footer.css'
import logo from '../../assets/logo.png'

import {BsFacebook} from 'react-icons/bs'
import {BsInstagram} from 'react-icons/bs'
import {BsTwitter} from 'react-icons/bs'
import {BsLinkedin} from 'react-icons/bs'

import {IoMdMail} from 'react-icons/io'
import {BsFillTelephoneFill} from 'react-icons/bs'

import {TbBrandFiverr} from 'react-icons/tb'


const Footer = () => {
  return (
    <footer>
        <div className="container-footer">
            <div className="left-footer">
                <div className="left-logo">
                  <a href="./#"><img src={logo} alt="" loading='lazy' /></a>                  
                </div>
                <div className="left-text">
                    <span>WebHarvester Agency is a leading digital marketing agency that specializes in providing high-quality B2B lead generation services. With a strong Fiverr track record since 2020, we also offer data entry and web research services.</span>
                </div>
                <div className="left-icons">
                    <a href=""><BsFacebook /></a>
                    <a href=""><BsInstagram /></a>
                    <a href=""><BsTwitter/></a>
                    <a href="https://www.linkedin.com/company/webharvester-agency/" target='blank'><BsLinkedin /></a>
                    <a href="https://www.fiverr.com/smbristy" target='blank'><TbBrandFiverr /></a>
                </div>
            </div>

            <div className="middle-footer">
                <span>Quick Links</span>

                <ul className='permalinks'>
                    <li><a href='./#'>Home</a></li>
                    <li><a href='./#about'>About</a></li>
                    <li><a href='./#services'>Services</a></li>
                    <li><a href='./#projects'>Projects</a></li>
                    <li><a href='./#team'>Our Team</a></li>
                    <li><a href='./#contact'>Contact</a></li>
                </ul>
            </div>

            <div className="right-footer">
                <span>Contact Info</span>

                <div className="right-container">
                    <a href="tel: +880 1717-170995" target='blank'>
                        <span className="right-logo"><BsFillTelephoneFill /></span>
                        <span className="right-text">+880 1717-170995</span>
                    </a>
                    <a href="mailto: contact@webharvester.agency" target='blank'>
                        <span className="right-logo"><IoMdMail /></span>
                        <span className="right-text">contact@webharvester.agency</span>
                    </a>
                </div>
            </div>
        </div>

        <div className="copyright">
            <span className="line"></span>

            <small>&copy; <a href="https://webharvester.agency/" target='blank'>WebHarvester Agency</a>. All rights reserved.</small>

            <span className="credit">Developed By: <a href="https://mrmahi03.netlify.app/" target='blank'>Md. Hasibul Hasan</a></span>
        </div>
    </footer>
  )
}

export default Footer;